import React from "react";
import { FormControl, FormLabel } from '@mui/material';
import CreatableSelect from 'react-select/creatable/dist/react-select.esm';
import Select from 'react-select/dist/react-select.esm';

export default ({ name, value, options, onCreateOption, onChange, disabled, allowFreeform = true }) => {
  const menuStyles = {
    menu: (styles) => ({
      ...styles,
      zIndex: 1000,
    }),
  };

  return (
    <FormControl fullWidth={true}>
      <FormLabel>{name}</FormLabel>
      {allowFreeform ? (
        <CreatableSelect options={options}
                         isClearable={true}
                         isDisabled={disabled}
                         styles={menuStyles}
                         value={value}
                         fullWidth={true}
                         onChange={onChange}
                         onCreateOption={onCreateOption}/>
      ) : (
        <Select options={options}
                isClearable={true}
                isDisabled={disabled}
                styles={menuStyles}
                value={value}
                fullWidth={true}
                onChange={onChange}/>
      )}
    </FormControl>
  );
};
